import { useState, useMemo, useContext, useEffect } from "react";
import { SocketContext } from "../context/socket";

import axios from "axios";
const SERVER_URL = window.location.protocol + "//" + window.location.host;

export default function useFlags() {
   const socket = useContext(SocketContext);
   const [fileList, setFileList] = useState([]);

   const handlers = useMemo(
      () => ({
         getFileList: () => {
            axios
               .get(SERVER_URL + "/api/getFlags/")
               .then(function (response) {
                  setFileList(response.data);
               });
         }
      }),
      [socket]
   );

   return [
      fileList,
      handlers,
   ];
}
